function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5913 18.7168L14.8957 13.7662C16.103 12.3113 16.7645 10.4807 16.7645 8.57499C16.7645 4.12251 13.1911 0.5 8.79888 0.5C4.4067 0.5 0.833252 4.12251 0.833252 8.57499C0.833252 13.0275 4.4067 16.65 8.79888 16.65C10.4478 16.65 12.0191 16.1458 13.3625 15.1888L18.0937 20.177C18.2915 20.3852 18.5575 20.5 18.8425 20.5C19.1123 20.5 19.3682 20.3957 19.5625 20.2061C19.9753 19.8034 19.9885 19.1357 19.5913 18.7168ZM8.79888 2.60652C12.0454 2.60652 14.6865 5.28391 14.6865 8.57499C14.6865 11.8661 12.0454 14.5435 8.79888 14.5435C5.55237 14.5435 2.91124 11.8661 2.91124 8.57499C2.91124 5.28391 5.55237 2.60652 8.79888 2.60652Z",
  fill: "#1C9CE4"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.76b31cf8.svg";
export { ForwardRef as ReactComponent };